/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQueryService extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQueryService");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQueryService.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQueryService>): AutomationTemplateQueryService {
        let obj = Object.assign(new AutomationTemplateQueryService(), model);
        AutomationTemplateQueryService.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQueryService>): AutomationTemplateQueryService {
        if (!model) return null;
        return AutomationTemplateQueryService.newInstance(<AutomationTemplateQueryService> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQueryService) {
        if (!obj) return;

        models.AutomationTemplateQueryService.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQueryService): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQueryService.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service(s) associated with the template.
     */
    services: Array<models.CloudServiceName>;

}
